// packages/shared/src/constants/programme-body-states.ts
export const PROGRAMME_BODY_KINDS = ["working_group", "committee"];
export const PROGRAMME_BODY_MEMBER_ROLES = ["chair", "member", "observer", "secretary"];
export const PROGRAMME_MEETING_STATUSES = [
    "scheduled",
    "in_progress",
    "completed",
    "archived",
];
export const PROGRAMME_ATTENDANCE_STATUSES = ["present", "apologies", "absent", "proxy"];
const TRANSITIONS = {
    scheduled: ["in_progress", "archived"],
    in_progress: ["completed", "scheduled"], // scheduled = reopen before close
    completed: ["archived"],
    archived: [],
};
export function canTransitionProgrammeMeeting(from, to) {
    return (TRANSITIONS[from] ?? []).includes(to);
}
//# sourceMappingURL=programme-body-states.js.map